import React from 'react';
import { Link } from "react-router-dom";

// import icLogoPng from '../../Assets/Images/ic-logo.png';
// import icLogoMobilePng from '../../Assets/Images/ic-logo-mobile.png';
import icLogo from '../../Assets/Images/ic-logo.svg';
import icLogoMobile from '../../Assets/Images/ic-logo-mobile.svg';
import bleatLogo from '../../Assets/Images/logo-bleat.svg';
import bleatLogoMobile from '../../Assets/Images/logo-bleat-mobile.svg';
import useWindowDimensions from '../../Hooks/useWindowDimensions';

const Header = props => {

  const { windowWidth } = useWindowDimensions();

  return (
    <>
      <header>
        <div className="header-wrapper">
        
          {windowWidth > 830 ? <Link to="/start" className="logo"><img src={icLogo} alt="Logo" /></Link> : <Link to="/start" className="logo"><img src={icLogoMobile} alt="Logo" /></Link>}
          
          <div className="assessment-title desktop" id="assessment-title">
            <p className="logo-text">ChurchOS Activation</p>
            <p className="logo-subtext">ASSESSMENT</p>
          </div>

          {/* { windowWidth > 830 &&
            <div className="bleat-logo"><img src={bleatLogo} alt="bleat logo" height="57px" width="50px" /></div>
          } */}

        {/* {windowWidth <= 830 ?
          (<div className="bleat-logo-mobile">
            <img src={bleatLogoMobile} alt="bleat logo" height="43px" width="auto" />
          </div>) : (<div className="bleat-logo"><img src={bleatLogo} alt="bleat logo" height="57px" width="50px" /></div>)} */}

        </div>

      </header>
    </>
  )
}

export default Header;
